import { render } from "./NewUser.vue?vue&type=template&id=46012596&scoped=true"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"

import "./NewUser.vue?vue&type=style&index=0&id=46012596&scoped=true&lang=css"
import "./NewUser.vue?vue&type=style&index=1&id=46012596&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46012596"]])

export default __exports__